import React from "react"
import { valrops } from "components/ui/utils"

interface props {
    data?: valrops
    dataColor?: any
}

function ValueIcon({ data, dataColor = "#333" }: props): JSX.Element  {
    if (!data) {
            return (
                <>
                <circle cx="32" cy="32" r="6" fill="#FF4500" stroke="#333" stroke-width="2"/>
                <line x1="28" y1="32" x2="36" y2="32" stroke="#333" stroke-width="2"/>
                <line x1="32" y1="28" x2="32" y2="36" stroke="#333" stroke-width="2"/>
                </>
        )
    }

    const textColor = data?.color ? data.color : dataColor

    return <text x="14" y="36" font-family="Arial" font-size="6" fill={textColor} font-weight="bold">{data.text}</text>
}

function GrpIcon(props: React.PropsWithChildren<React.SVGProps<SVGSVGElement>> & props): JSX.Element  {
    return (
        <svg
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="none"
            className="grp"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="12" y="20" width="40" height="24" rx="2" fill="#FFD700" stroke="#333" stroke-width="2"/>
        
            <rect x="4" y="28" width="8" height="8" fill="#87CEEB" stroke="#333" stroke-width="2"/>
            <circle cx="8" cy="32" r="2" fill="#333"/>
        
            <rect x="52" y="28" width="8" height="8" fill="#32CD32" stroke="#333" stroke-width="2"/>
            <circle cx="56" cy="32" r="2" fill="#333"/>
        
            <rect x="8" y="44" width="48" height="4" fill="#666" stroke="#333" stroke-width="2"/>
            
            <ValueIcon {...props} />
      </svg>
    )
}

export default GrpIcon
